
import rpb01 from "./rpb01";
import rpb02 from "./rpb02";
import rpb03 from "./rpb03";
import rpb04 from "./rpb04";
import rpb05 from "./rpb05";

export default {
    rpb01,
    rpb02,
    rpb03,
    rpb04,
    rpb05
}